<template>
  <div class="versions-dialog-box">

    <div class="qa-dialog-fix-height-table">
      <el-dialog
        width-size="medium"
        height-size="fixed-auto"
        :title="title"
        @close="onClose"
        visible>

        <el-table
          row-key="id"
          :border-top="false"
          border-bottom
          :show-header="false"
          :loading-append="isTableDataLoading"
          :data="fileVersions">

          <el-table-column
            prop="id"
            hidden/>

          <el-table-column
            prop="crtInternalId"
            hidden/>

          <el-table-column
            prop="version">
            <template slot-scope="{ row }">
              {{ row.version | date }}
            </template>
          </el-table-column>

          <el-table-column
            align="right"
            prop="size">
            <template slot-scope="{ row }">
              {{ row.size | size }}
            </template>
          </el-table-column>

          <el-table-column
            align="right"
            width="280">
            <template slot-scope="{ row }">
              <el-button
                v-if="appFeatures.notaryEnabled && row.notarized"
                type="ghost"
                @click="$emit('verify', row, row.id)">
                <el-tooltip
                  class="item"
                  :content="$t('wr-dashboard.content-table.action.notary-verify')"
                  placement="bottom">
                  <el-icon
                    class="ml-8"
                    name="i-license--16"
                    color="brand-primary"/>
                </el-tooltip>
              </el-button>

              <el-button
                v-if="appFeatures.notaryEnabled && row.notarized"
                type="ghost"
                @click="$emit('certificate', row.crtInternalId)">
                <el-tooltip
                  class="item"
                  :content="$t('wr-dashboard.content-table.action.notary-get-crt')"
                  placement="bottom">
                  <el-icon
                    class="ml-8"
                    name="i-file-notarization-o--16"
                    color="brand-primary"/>
                </el-tooltip>
              </el-button>

              <el-button
                v-if="appFeatures.asignEnabled && row.size > 0"
                type="ghost"
                @click="$emit('asign', row.id)">
                <el-tooltip
                  class="item"
                  :content="$t('wr-dashboard.content-table.action.asign')"
                  placement="bottom">
                  <el-icon
                    class="ml-8"
                    name="i-esign-o--16"
                    color="brand-primary"/>
                </el-tooltip>
              </el-button>

              <el-button
                type="ghost"
                @click="$emit('restore', row.id, false)">
                <el-tooltip
                  class="item"
                  :content="$t('wr-dashboard.content-table.action.restore')"
                  placement="bottom">
                  <el-icon
                    class="ml-8"
                    name="i-download--16"
                    color="brand-primary"/>
                </el-tooltip>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <template #footer>
          <el-button
            @click="onClose"
            native-type="button"
            type="secondary">
            {{ $t('wr-dashboard.form.button.close') }}
          </el-button>
        </template>
      </el-dialog>
    </div>

  </div>
</template>

<script>

export default {
  name: 'VersionsDialogBox',
  props: {
    fileVersions: {
      type: Array,
      default: () => [],
      required: true
    },
    fileName: {
      type: String,
      default: '',
      required: true
    },
    appFeatures: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  data() {
    return {
    };
  },
  computed: {
    title() {
      return this.$t('wr-dashboard.versions-dialog-box.title', { fileName: this.fileName });
    },
    isTableDataLoading() {
      return this.fileVersions.length === 0;
    }
  },
  methods: {
    onClose() {
      this.$emit('handleClose');
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
